<header #info class="restaurant-wrap container-xl shadow-sm border">
  <div class="alert" *ngIf="announceIndex" (click)="openAnnounce()">

    <div>
       <b>
        {{ announceIndex>=10?"9+":announceIndex }}</b>
<svg width="30px" height="30px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>alert</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-364.000000, -882.000000)" fill="#FFC50F"> <path d="M388,900 L388,892 C388,886.478 383.522,882 378,882 C372.478,882 368,886.478 368,892 L368,900 L364,908 L375.184,908 C375.597,909.163 376.695,910 378,910 C379.305,910 380.403,909.163 380.816,908 L392,908 L388,900" id="alert" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>
    </div>

  </div>



  <div class="restaurant-pictures row">
    <!-- restaurant background picture -->
    <span
      *ngIf="storeData?.banner"
      class="restaurant-background-picture col-12 gx-0 shadow-sm user-select-none"
      [ngStyle]="{
        background: 'url(' + storeData?.banner + ') 0% 0% / cover no-repeat',
        'background-position-x': 'center'
      }"
    >
    </span>
    <!-- restaurant logo picture -->
    <div
      class="restaurant-logo-wrap rounded border shadow align-items-center"
      *ngIf="storeData?.logo"
    >
      <!-- ; else defaultLogo -->
      <picture class="restaurant-logo">
        <source [srcset]="storeData?.logo" />
        <img [src]="storeData?.logo" class="img-fluid" />
      </picture>
      <!-- <ng-template #defaultLogo>
        <picture class="restaurant-logo">
          <source
            sizes=""
            srcset="../../../../../../assets/images/example/up-logo.png"
          />
          <img
            src="../../../../../../assets/images/example/up-logo.png"
            class="img-fluid"
            alt=""
          />
        </picture>
      </ng-template> -->
    </div>
  </div>
  <div class="row p-3">
    <div class="col-12 col-sm-8 col-lg-9 gx-0" *ngIf="storeData">
      <div class="col-12 fs-1 text-dark fw-bolder user-select-none">
        {{ storeData?.store_name }}
      </div>
      <ng-container *ngIf="storeData.closure">
        <div class="text-danger fs-5 fw-bold">
          This store is offline.{{ storeData.closure }}
        </div>
      </ng-container>
      <div
        class="d-flex flex-column d-lg-inline-flex flex-lg-row flex-wrap text-secondary fw-bold"
      >
        <div class="d-inline-flex">
          <a
            class="text-dark"
            placement="bottom"
            ngbTooltip="Find store"
            [href]="
              'http://maps.google.com/?q=' +
              storeData?.address +
              ',' +
              storeData?.city +
              ',' +
              storeData?.state +
              ',' +
              storeData?.zipcode
            "
            target="_blank"
          >
            {{ storeData?.address + "," }}
            <ng-container *ngIf="storeData?.optional">
              {{ storeData?.optional + "," }}
            </ng-container>
            {{ storeData?.city + "," | titlecase }}
            {{ storeData?.state + "," | titlecase }}
            {{ storeData?.zipcode }}</a
          >

          <!-- • Mexican, Deli, Chinese • 3.8⭐ • $$ -->
        </div>
        <ng-container>
          <ng-container
            *ngFor="
              let businessHour of storeData?.business_hour;
              let businessHourIndex = index
            "
          >
            <ng-container *ngIf="parseDay(businessHour?.scope!)">
              <div class="d-none d-lg-block">&nbsp;•&nbsp;</div>
              {{ businessHour?.open_hour }}&nbsp;-&nbsp;{{
                businessHour?.close_hour
              }}</ng-container
            >
          </ng-container>
          <ng-container *ngIf="storeData?.phone!">
            <span class="d-none d-lg-block ms-1 me-1">&nbsp;•&nbsp;</span>
            <a
              [href]="'tel:' + storeData?.phone!"
              class="text-dark"
              placement="bottom"
              ngbTooltip="Call store"
              ><div class="d-inline-flex">
                {{ storeData?.phone! | phone }}
              </div>
            </a></ng-container
          >
          <!-- <ng-container>
            <span class="d-none d-lg-block ms-1 me-1">&nbsp;•&nbsp;</span>
            <a
              class="text-dark"
              (click)="anchorToFooter('storeHourAnckor')"
              placement="bottom"
              ngbTooltip="See store full schedule"
            >
              About
            </a></ng-container
          > -->
        </ng-container>
      </div>
    </div>
    <div
      class="col-12 col-sm-4 col-lg-3 gx-0 mb-1 mb-sm-0 mt-1 mt-sm-0 d-sm-flex align-items-sm-center justify-content-sm-end"
      *ngIf="storeData?.is_catering === 1"
    >
      <button
        type="button"
        class="btn btn-md border rounded fw-bold text-nowrap text-danger"
        (click)="openCatering()"
      >
        Catering Form
      </button>
    </div>
  </div>
  <!-- <div class="alert alert-danger text-center user-select-none h6" role="alert">
    This is a pick-up order
  </div>
  <div class="alert alert-warning text-center" role="alert">
    <p class="h6 user-select-none"> You're out of range</p>
    <p class="user-select-none">This restaurant can't be delivered to Flushing, NY 11355, USA.
    </p>
  </div> -->


</header>
